import m from 'mithril'
import { initMithrilComponent } from '@client-shared/utils/mithril'
import UploadsContainer from '../uploads-container'
import UploadsManager, { type UpdateHandlerFunc } from '../../util/uploads-manager'
import AlertDialog, { ALERT_DIALOG_VARIANTS } from '@client-shared/components-v2/alert-dialog'

import s from './uploads-container-overlay.module.scss'

export const EVENT_SHOW_UPLOADS_CONTAINER_OVERLAY = 'uploads-container:show-overlay'

interface State {
	cancel_upload_id: string
	is_canceling_upload: boolean
	show_uploads_manager: boolean
	prev_show_uploads_container_overlay_value?: boolean
	uploadItemsUpdateHandler: UpdateHandlerFunc
	externalShowEventHandler: (e: CustomEventInit<boolean>) => void
}

const UploadsContainerOverlay = initMithrilComponent<undefined, State>()

UploadsContainerOverlay.oninit = (vnode) => {
	vnode.state.cancel_upload_id = ''
	vnode.state.is_canceling_upload = false
	vnode.state.show_uploads_manager = UploadsManager.uploads_in_progress

	vnode.state.uploadItemsUpdateHandler = async () => {
		vnode.state.show_uploads_manager = vnode.state.prev_show_uploads_container_overlay_value
			? UploadsManager.upload_items.length > 0
			: false

		m.redraw()
	}

	vnode.state.externalShowEventHandler = (e) => {
		const show_overlay = e.detail

		vnode.state.prev_show_uploads_container_overlay_value = show_overlay
		vnode.state.show_uploads_manager = show_overlay ? UploadsManager.uploads_in_progress : false

		m.redraw()
	}

	window.addEventListener(EVENT_SHOW_UPLOADS_CONTAINER_OVERLAY, vnode.state.externalShowEventHandler)

	UploadsManager.onUpdate(vnode.state.uploadItemsUpdateHandler)
}

UploadsContainerOverlay.onremove = (vnode) => {
	window.removeEventListener(EVENT_SHOW_UPLOADS_CONTAINER_OVERLAY, vnode.state.externalShowEventHandler)

	UploadsManager.removeUpdateHandler(vnode.state.uploadItemsUpdateHandler)
}

UploadsContainerOverlay.view = (vnode) => {
	return m('div', { class: s.uploads_container_overlay }, [
		vnode.state.show_uploads_manager &&
			m(UploadsContainer, {
				class: s.uploads_container,
				onCancelUpload: (upload_id) => {
					vnode.state.cancel_upload_id = upload_id
				},
				onClose: () => {
					if (UploadsManager.uploads_in_progress) {
						return
					}

					vnode.state.show_uploads_manager = false

					UploadsManager.clearInactiveItems()
				},
			}),
		vnode.state.cancel_upload_id !== '' &&
			m(
				AlertDialog,
				{
					headerText: 'Cancel upload?',
					variant: ALERT_DIALOG_VARIANTS.DANGER,
					isBusy: vnode.state.is_canceling_upload,
					buttonCancelText: 'No, go back',
					buttonConfirmText: 'Yes, cancel the upload',
					buttonConfirmBusyText: 'Canceling...',
					onCancel: () => {
						vnode.state.cancel_upload_id = ''
					},
					onConfirm: async () => {
						vnode.state.is_canceling_upload = true

						UploadsManager.cancel(vnode.state.cancel_upload_id)

						vnode.state.cancel_upload_id = ''
						vnode.state.is_canceling_upload = false
						m.redraw()
					},
				},
				'Are you sure you want to cancel this upload?',
			),
	])
}

export default UploadsContainerOverlay
